













































import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'
import openCamera from '@/lib/open-camera'
import { base64ToBlob, getQueryString, sendMessage } from '@/lib/common-util'
import { uploadHandlerV2 } from '@/lib/photograph-flow/flow/upload'
import 'vue-loading-overlay/dist/vue-loading.css'
import { getReport, sendReport } from '@/lib/imageReportPc'
import DialogPrompt from '@/views/common/DialogPrompt.vue'
import store from '@/store'
// tslint:disable-next-line
const Loading = require('vue-loading-overlay')
import {v1 as uuidv1} from 'uuid';
interface IProps {
  className: string
  title: string
  goNext: (image: string) => void
}

interface INewVideo extends HTMLVideoElement {
  mozSrcObject?: any
  srcObject: any
  src: any
}

interface ICamObj {
  video: INewVideo
  stream: any
}
let streamData = {
  video: null as any,
  stream: null as any,
}
interface IUploadResult {
  code?: string,
  message?: string,
  uploadTime?: number,
  transactionId?: string,
  score?: number,
  errorMsg?: string,
  tryCount?: number,
  returnUrl?: string,
  failedReturnUrl?: string,
}
@Component({components: {[Button.name]: Button, Loading, DialogPrompt}})
export default class RecordFace extends Vue {
  loading: boolean = false
  width: number = 500
  height: number = 455
  context: any = null
  tempdata: ICamObj | null = null
  timer: any = 0
  isUploadFailed: boolean = false
  takePhotoTimestamp: number = 0

  pcResultPageShow: number = 1

  savePic(width: number, height: number, camObj: ICamObj) {
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    const $originDom = document.querySelector('#image') as HTMLCanvasElement
    if (ctx) {
      ctx.drawImage(
        camObj.video,
        camObj.video.offsetLeft - ($originDom.offsetLeft || 0),
        camObj.video.offsetTop - ($originDom.offsetTop || 0),
        camObj.video.offsetWidth,
        camObj.video.offsetHeight,
      )
    }
    return canvas.toDataURL('image/jpeg')
  }

  drawOutline($dom: HTMLCanvasElement) {
    const width = $dom.width
    const height = $dom.height
    return (ctx: CanvasRenderingContext2D) => {
      ctx.save()
      ctx.beginPath()
      ctx.rect(0, 0, width, height)
      ctx.fillStyle = 'rgba(0,0,0,0.6)'
      ctx.fill()
      ctx.closePath()
      ctx.globalCompositeOperation = 'xor'
      ctx.beginPath()
      ctx.strokeStyle = 'rgb(255,255,255)'
      ctx.fillStyle = 'rgba(255,255,255,1)'
      ctx.lineWidth = 3
      ctx.arc(250, 225, 200, 0, 2 * Math.PI)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
      ctx.restore()
    }
  }
  closeCamera(data: any) {
    if (data) {
      const [track] = data.stream.getTracks() || []
      track.stop()
    } else {
      const [track] = streamData.stream.getTracks() || []
      track.stop()
    }
  }
  async btnClick() {
    this.takePhotoTimestamp = new Date().getTime()
    let imgBase64 = this.savePic(this.width, this.height, streamData)
    const imgBolb = base64ToBlob(imgBase64)
    this.loading = true
    this.clearData()
    try {
      const uploadStartTime = new Date().getTime()
      const uploadResult = await uploadHandlerV2({
        images: [imgBolb],
      }, this.$route.query.biz_token as string)

      // console.log(this.pcResultPage, this.pcResultPage.isShow === false)
      if (this.pcResultPage && this.pcResultPage.isShow === false) {
        this.pcResultPageShow = 0
      } else {
        this.pcResultPageShow = 1
      }

      // console.log(this.pcResultPageShow)

      if (uploadResult.code === 'SUCCESS') {
        // *活体拍摄且上传成功 =》跳转
        this.sendReportUpload(true, uploadResult.message || '', { uploadTime: new Date().getTime() - uploadStartTime, ...uploadResult.data })
        if (!this.pcResultPageShow) {
          this.pcJumpHandler(uploadResult)
          return
        }
        this.$router.push({
          name: 'webResultV2',
          query: {
            biz_token: this.$route.query.biz_token,
            result: uploadResult.code,
            message: uploadResult.message,
            score: uploadResult.data.score,
            returnUrl: uploadResult.data ? encodeURIComponent(uploadResult.data.returnUrl) : '',
            failedReturnUrl: uploadResult.data ? encodeURIComponent(uploadResult.data.failedReturnUrl) : '',
            tryCount: uploadResult.data.tryCount,
            fromName: this.$route.query.fromName,
            faceImage: uploadResult.data && uploadResult.data.imageUrl ? uploadResult.data.imageUrl : '',
          },
        })
      } else {
        // console.log(888888, uploadResult)
        this.sendReportUpload(false, uploadResult.message || '', { uploadTime: new Date().getTime() - uploadStartTime, ...uploadResult.data })
        if (!this.pcResultPageShow) {
          this.pcJumpHandler(uploadResult)
          return
        }
        this.$router.push({
          name: 'webResultV2',
          query: {
            biz_token: this.$route.query.biz_token,
            result: uploadResult.code,
            message: uploadResult.message,
            tryCount: uploadResult.data ? uploadResult.data.tryCount : 0,
            returnUrl: uploadResult.data ? encodeURIComponent(uploadResult.data.returnUrl) : '',
            failedReturnUrl: uploadResult.data ? encodeURIComponent(uploadResult.data.failedReturnUrl) : '',
            faceImage: uploadResult.data && uploadResult.data.imageUrl ? uploadResult.data.imageUrl : '',
          },
        })
      }
      this.loading = false
    } catch (error) {
      this.loading = false
      this.isUploadFailed = true
      this.sendReportUpload(false, (error as any).messages, {})
      return
    }
  }
  pcJumpHandler(data: any) {
    try {
      let url: string = ''
      // code 为成功 且 分数大于50分为检测成功
      if (data.code && data.code === 'SUCCESS' && data.data && data.data.score && data.data.score > 50) {
        const returnUrl = data.data.returnUrl
        if (returnUrl.indexOf('?') !== -1) {
          const queryStr = returnUrl.split('?')[1]
          const isIframe = getQueryString('isLivenessIframe', queryStr)
          if (isIframe && isIframe !== 'false') {
            sendMessage({info: 'successNext'})
            return
          } else {
            url = `${returnUrl}&successCode=${data.code}&version=image`
          }
        } else {
          url = `${returnUrl}?successCode=${data.code}&version=image`
        }
      } else {
        const failedReturnUrl = data.data.failedReturnUrl
        if (failedReturnUrl.indexOf('?') !== -1) {
          const queryStr = failedReturnUrl.split('?')[1]
          const isIframe = getQueryString('isLivenessIframe', queryStr)
          if (isIframe && isIframe !== 'false') {
            sendMessage({info: 'failedNext'})
            return
          } else {
            url = `${failedReturnUrl}&failCode=${data.code || ''}&message=${data.message}&version=image`
          }
        } else {
          url = `${failedReturnUrl}?failCode=${data.code || ''}&message=${data.message}&version=image`
        }
      }
      if (url.length > 0) {
        window.location.href = url
        return
      }
    } catch (e) {
      this.$router.push({
        name: 'webResultV2',
        query: {
          biz_token: this.$route.query.biz_token,
          result: data.code,
          message: data.message,
          tryCount: data.data ? data.data.tryCount : 0,
          returnUrl: data.data ? encodeURIComponent(data.data.returnUrl) : '',
          failedReturnUrl: data.data ? encodeURIComponent(data.data.failedReturnUrl) : '',
          faceImage: data.data ? data.data.imageUrl : '',
        },
      })
    } finally {
      this.loading = false
    }
  }
  getReportResolve(result: boolean, message: string) {
    const report = getReport()
    const eventTimestamp: any = this.$route.query.eventTimestamp || -1
    report.eventTimestamp = Number(eventTimestamp)
    report.takePhotoTimestamp = this.takePhotoTimestamp
    const reportDetail = report.info.detail
    reportDetail.state = 'RESOLVE'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.imageOrigFormat = 'jpeg'
    reportDetail.imageOrigSize = this.savePic(this.width, this.height, streamData).length
    reportDetail.imageOrigWidth = this.width
    reportDetail.imageOrigHeight = this.height
    reportDetail.userId = this.$route.query.userId || ''
    reportDetail.isResolved = false
    return report
  }
  sendReportUpload(result: boolean, message: string, uploadResult: IUploadResult) {
    const report = this.getReportResolve(result, message)
    const reportDetail = report.info.detail
    reportDetail.state = 'UPLOAD'
    if (uploadResult) {
      reportDetail.uploadTime = uploadResult.uploadTime
      reportDetail.transactionId = uploadResult.transactionId
      reportDetail.score = uploadResult.score
      reportDetail.tryCount = uploadResult.tryCount
      reportDetail.returnUrl = uploadResult.returnUrl
      reportDetail.failedReturnUrl = uploadResult.failedReturnUrl
    }
    sendReport(report)
  }
  get uuid() {
    return uuidv1() + '.webm'
  }
  get pcResultPage() {
    const resultTextConStr = sessionStorage.getItem('resultTextCon') || '{}'
    const resultTextCon = JSON.parse(resultTextConStr) || {}
    return resultTextCon.pcResultPage || {}
  }
  get pcCameraPage() {
    const resultTextConStr = sessionStorage.getItem('resultTextCon') || '{}'
    let resultTextCon = JSON.parse(resultTextConStr) || {}
    return resultTextCon.pcCameraPage || {}
  }
  get titleTexta() {
    const title = localStorage.getItem('titleText') || 'Liveness Detection'
    return title
  }
  get pcLoadingPage() {
    const resultTextConStr = sessionStorage.getItem('resultTextCon') || '{}'
    const resultTextCon = JSON.parse(resultTextConStr) || {}
    return resultTextCon.pcLoadingPage || {}
  }
  get pcErrorDialog() {
    const resultTextConStr = sessionStorage.getItem('resultTextCon') || '{}'
    const resultTextCon = JSON.parse(resultTextConStr) || {}
    return resultTextCon.pcErrorDialog || {}
  }
  clearData() {
    this.context = null
    this.closeCamera(this.tempdata)
    clearInterval(this.timer)
    this.tempdata = null
  }
  hideDialogHandler() {
    this.isUploadFailed = false
    location.reload()
  }
  toOpenCamera() {
    const $video = document.querySelector('#video') as HTMLVideoElement
    const obj = openCamera($video)
    const $canvas = document.querySelector('#image') as HTMLCanvasElement
    $canvas.width  = this.width
    $canvas.height = this.height
    this.context = $canvas.getContext('2d')
    const doOutline = this.drawOutline($canvas)
    obj.then((data: any) => {
      if (data) {
        this.timer = window.setInterval(() => {
          if (this.context) {
            this.context.drawImage(
              data.video,
              data.video.offsetLeft - ($canvas.offsetLeft || 0),
              data.video.offsetTop - ($canvas.offsetTop || 0),
              data.video.offsetWidth,
              data.video.offsetHeight,
            )
            streamData = data
            this.tempdata = data
            doOutline(this.context as CanvasRenderingContext2D)
          }
        }, 0) // 设置默认值为0，根据不同浏览器本身默认值之行，如果设置默认值，不同刷新率显示器可能看到效果不同
      }
    })
  }
  mounted() {
    store.bizToken = this.$route.query.biz_token as string
    sessionStorage.setItem('bizToken', this.$route.query.biz_token as string)
    this.toOpenCamera()
  }
  destroyed() {
    this.clearData()
  }
}
